/* True if the user setting to allow hovering on tooltips is enabled
 * VSO:3877410 ease of access settings will need to integrate with this */
let hoverableTooltipsPreference: boolean = false;

export const setHoverableTooltipsPreference = (isEnabled: boolean) => {
  hoverableTooltipsPreference = isEnabled;
};

export function getHoverableTooltipsPreference(): boolean {
  return hoverableTooltipsPreference;
}
